import { useQuery } from "@tanstack/react-query";
import { getStatsTickets } from "../../api/STATISTIQUES/statistiques";

export const useStatsTickets = (filters = {}) => {
  return useQuery({
    queryKey: ["statsTickets", filters],
    queryFn: () => getStatsTickets(filters),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
